/**
 * Detects if the app is running in standalone mode (PWA) or as a regular website
 * @returns {boolean} True if running as PWA, false otherwise
 */
export const isPWA = () => {
  // Check if running in standalone mode (PWA)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone // iOS Safari
    || document.referrer.includes('android-app://');

  return isStandalone;
};

/**
 * Detects if the app is running in Safari on iOS
 * @returns {boolean} True if running in Safari on iOS
 */
export const isIOSSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  
  return iOSSafari;
};

/**
 * Gets the current display mode of the app
 * @returns {'standalone' | 'browser' | 'ios-safari'} The current display mode
 */
export const getDisplayMode = () => {
  if (isPWA()) {
    return 'standalone';
  }
  if (isIOSSafari()) {
    return 'ios-safari';
  }
  return 'browser';
}; 